/**
 * Customer Love It — video carousel (Flickity + optional HLS)
 */
(function () {
  'use strict';

  var HLS_SRC = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.7/dist/hls.min.js';

  function loadHlsJs(callback) {
    if (window.Hls) {
      callback();
      return;
    }
    if (window.__customerLoveItHlsLoading) {
      window.__customerLoveItHlsLoading.then(callback);
      return;
    }
    window.__customerLoveItHlsLoading = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = HLS_SRC;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
    window.__customerLoveItHlsLoading.then(callback).catch(function () {});
  }

  function getSlidesToShow(slider) {
    var w = window.innerWidth;
    if (w > 1024) return parseFloat(slider.dataset.slidesDesktop) || 3;
    if (w >= 768) return parseFloat(slider.dataset.slidesTablet) || 2;
    return parseFloat(slider.dataset.slidesMobile) || 1;
  }

  function getCellAlign() {
    return window.innerWidth <= 767 ? 'left' : 'center';
  }

  function pauseAllVideos(section, exceptWrap) {
    if (section.dataset.allAutoplay === '1') return;
    section.querySelectorAll('.customer-love-it__video-wrap').forEach(function (wrap) {
      if (exceptWrap && wrap === exceptWrap) return;
      var video = wrap.querySelector('video');
      var playBtn = wrap.querySelector('.customer-love-it__play');
      var poster = wrap.querySelector('.customer-love-it__poster');
      var muteBtn = wrap.querySelector('.customer-love-it__mute');
      if (!video) return;
      video.pause();
      video.muted = true;
      playBtn && playBtn.classList.remove('is-playing');
      poster && poster.classList.remove('is-hidden');
      muteBtn && muteBtn.classList.add('is-muted');
    });
  }

  function attachProgress(video, wrap) {
    var bar = wrap.querySelector('.customer-love-it__progress-fill');
    if (!bar) return;
    var rafId = null;

    function tick() {
      if (!video.paused && !video.ended && video.duration > 0) {
        bar.style.width = (video.currentTime / video.duration) * 100 + '%';
        rafId = requestAnimationFrame(tick);
      }
    }

    video.addEventListener('play', function () {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(tick);
    });
    video.addEventListener('pause', function () {
      cancelAnimationFrame(rafId);
    });
    video.addEventListener('ended', function () {
      cancelAnimationFrame(rafId);
      bar.style.width = '0%';
    });
  }

  function setVideoSource(video, src, onReady) {
    if (!src) return;
    var isHls = src.indexOf('.m3u8') !== -1;

    if (video.hlsInstance) {
      try {
        video.hlsInstance.destroy();
      } catch (e) {}
      video.hlsInstance = null;
    }

    video.removeAttribute('src');
    Array.from(video.querySelectorAll('source')).forEach(function (s) {
      s.remove();
    });

    function done() {
      video.dataset.loadedSrc = src;
      if (typeof onReady === 'function') onReady();
    }

    if (isHls && video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
      video.addEventListener('loadedmetadata', done, { once: true });
      video.load();
      return;
    }

    if (isHls) {
      loadHlsJs(function () {
        if (!window.Hls || !Hls.isSupported()) {
          video.src = src;
          video.addEventListener('loadedmetadata', done, { once: true });
          video.load();
          return;
        }
        var hls = new Hls({ maxBufferLength: 4, startLevel: -1 });
        hls.loadSource(src);
        hls.attachMedia(video);
        video.hlsInstance = hls;
        hls.on(Hls.Events.MANIFEST_PARSED, done);
      });
      return;
    }

    var source = document.createElement('source');
    source.src = src;
    source.type = 'video/mp4';
    video.appendChild(source);
    video.addEventListener('loadedmetadata', done, { once: true });
    video.load();
  }

  function playVideo(wrap, section, flkty) {
    var video = wrap.querySelector('video');
    var playBtn = wrap.querySelector('.customer-love-it__play');
    var poster = wrap.querySelector('.customer-love-it__poster');
    var muteBtn = wrap.querySelector('.customer-love-it__mute');
    if (!video) return;

    var src = video.dataset.videoSrc;
    var cell = wrap.closest('.customer-love-it__cell');

    if (flkty && cell && !cell.classList.contains('is-selected')) {
      var idx = -1;
      for (var i = 0; i < flkty.cells.length; i++) {
        if (flkty.cells[i].element === cell) {
          idx = i;
          break;
        }
      }
      if (idx >= 0) flkty.select(idx);
    }

    function startPlayback() {
      pauseAllVideos(section, wrap);
      video.muted = false;
      muteBtn && muteBtn.classList.remove('is-muted');
      var promise = video.play();
      if (promise && promise.then) {
        promise
          .then(function () {
            playBtn && playBtn.classList.add('is-playing');
            poster && poster.classList.add('is-hidden');
          })
          .catch(function () {
            playBtn && playBtn.classList.remove('is-playing');
            poster && poster.classList.remove('is-hidden');
          });
      }
    }

    if (video.dataset.loadedSrc === src && src) {
      startPlayback();
      return;
    }

    setVideoSource(video, src, startPlayback);
  }

  function initVideoWrap(wrap, section, flkty) {
    if (wrap.dataset.videoInit === '1') return;
    wrap.dataset.videoInit = '1';

    var video = wrap.querySelector('video');
    var playBtn = wrap.querySelector('.customer-love-it__play');
    var muteBtn = wrap.querySelector('.customer-love-it__mute');
    var poster = wrap.querySelector('.customer-love-it__poster');
    if (!video) return;

    attachProgress(video, wrap);

    playBtn &&
      playBtn.addEventListener('click', function () {
        if (video.paused) {
          playVideo(wrap, section, flkty);
        } else {
          video.pause();
          video.muted = true;
          playBtn.classList.remove('is-playing');
          poster && poster.classList.remove('is-hidden');
          muteBtn && muteBtn.classList.add('is-muted');
        }
      });

    muteBtn &&
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        muteBtn.classList.toggle('is-muted', video.muted);
        var mutedLabel = muteBtn.getAttribute('data-muted-label');
        var unmutedLabel = muteBtn.getAttribute('data-unmuted-label');
        muteBtn.setAttribute('aria-label', video.muted ? mutedLabel : unmutedLabel);
      });

    video.addEventListener('playing', function () {
      poster && poster.classList.add('is-hidden');
      playBtn && playBtn.classList.add('is-playing');
    });

    video.addEventListener('ended', function () {
      playBtn && playBtn.classList.remove('is-playing');
      poster && poster.classList.remove('is-hidden');
      if (flkty) flkty.next();
    });
  }

  function isStackedMobile(section) {
    return section.classList.contains('customer-love-it--stacked-mobile') &&
      window.matchMedia('(max-width: 740px)').matches;
  }

  function initSlider(section) {
    var slider = section.querySelector('.customer-love-it__slider');
    if (!slider || typeof Flickity === 'undefined') return null;

    if (slider._customerLoveItFlkty) {
      slider._customerLoveItFlkty.destroy();
      slider._customerLoveItFlkty = null;
    }

    // Stacked layout is plain CSS grid; Flickity would fight it with inline widths.
    if (isStackedMobile(section)) {
      slider.querySelectorAll('.customer-love-it__cell').forEach(function (c) {
        c.style.width = '';
        c.style.left = '';
        c.style.position = '';
      });
      slider.style.height = '';
      if (window.AOS) AOS.refresh();
      section.querySelectorAll('[data-aos]').forEach(function (el) {
        el.classList.add('aos-animate');
      });
      autoplayAllVideos(section);
      return null;
    }

    var cells = slider.querySelectorAll('.customer-love-it__cell');
    var total = cells.length;
    var slidesToShow = getSlidesToShow(slider);
    var wrapAround = total > slidesToShow;
    var showNav = slider.dataset.showNav === 'true' && wrapAround;

    var flkty = new Flickity(slider, {
      cellSelector: '.customer-love-it__cell',
      cellAlign: getCellAlign(),
      contain: !wrapAround,
      wrapAround: wrapAround,
      imagesLoaded: true,
      prevNextButtons: showNav,
      pageDots: false,
      draggable: wrapAround,
      adaptiveHeight: false,
      percentPosition: false
    });

    slider._customerLoveItFlkty = flkty;

    // AOS mis-positioned sections below heavy media: the fade-in never fired
    // and the whole section stayed at opacity:0. Complete it once the slider
    // exists so these sections can never render invisible.
    if (window.AOS) AOS.refresh();
    section.querySelectorAll('[data-aos]').forEach(function (el) {
      el.classList.add('aos-animate');
    });

    var lastSlides = slidesToShow;
    var lastAlign = getCellAlign();

    function onResize() {
      var nextSlides = getSlidesToShow(slider);
      var nextAlign = getCellAlign();
      if (nextSlides !== lastSlides || nextAlign !== lastAlign) {
        lastSlides = nextSlides;
        lastAlign = nextAlign;
        initSlider(section);
        return;
      }
      flkty.resize();
    }

    if (!section._customerLoveItResizeBound) {
      section._customerLoveItResizeBound = true;
      window.addEventListener('resize', onResize);
    }

    flkty.on('settle', function () {
      autoplaySelectedSlide(section, flkty);
    });

    return flkty;
  }

  function autoplaySelectedSlide(section, flkty) {
    if (!flkty || !flkty.selectedElement) return;
    var wrap = flkty.selectedElement.querySelector('.customer-love-it__video-wrap');
    var video = wrap && wrap.querySelector('video');
    var playBtn = wrap && wrap.querySelector('.customer-love-it__play');
    var poster = wrap && wrap.querySelector('.customer-love-it__poster');
    var muteBtn = wrap && wrap.querySelector('.customer-love-it__mute');
    if (!video) return;

    pauseAllVideos(section, wrap);
    video.muted = true;
    muteBtn && muteBtn.classList.add('is-muted');

    var src = video.dataset.videoSrc;
    function tryPlay() {
      var promise = video.play();
      if (promise && promise.then) {
        promise
          .then(function () {
            playBtn && playBtn.classList.add('is-playing');
            poster && poster.classList.add('is-hidden');
          })
          .catch(function () {
            playBtn && playBtn.classList.remove('is-playing');
            poster && poster.classList.remove('is-hidden');
          });
      }
    }

    if (video.dataset.loadedSrc === src && src) {
      tryPlay();
      return;
    }
    setVideoSource(video, src, tryPlay);
  }

  // iOS/Safari refuse to autoplay when low power mode is on (or when the
  // page isn't "engaged" yet). Retry on the first user interaction and on
  // visibility change, so playback resumes without a visible dead state.
  function armAutoplayRetry(video) {
    if (!video || video.dataset.autoplayRetryArmed === '1') return;
    video.dataset.autoplayRetryArmed = '1';

    function retry() {
      if (!video.paused || video.dataset.userPaused === '1') return;
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    var events = ['touchstart', 'pointerdown', 'click', 'scroll', 'keydown'];
    events.forEach(function (evt) {
      document.addEventListener(evt, retry, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) retry();
    });
  }

  function autoplayAllVideos(section) {
    section.dataset.allAutoplay = '1';
    section.querySelectorAll('.customer-love-it__video-wrap').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var playBtn = wrap.querySelector('.customer-love-it__play');
      var poster = wrap.querySelector('.customer-love-it__poster');
      var muteBtn = wrap.querySelector('.customer-love-it__mute');
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      if (muteBtn) muteBtn.classList.add('is-muted');

      var src = video.dataset.videoSrc;

      function tryPlay() {
        var promise = video.play();
        if (promise && promise.then) {
          promise
            .then(function () {
              playBtn && playBtn.classList.add('is-playing');
              poster && poster.classList.add('is-hidden');
            })
            .catch(function () {
              playBtn && playBtn.classList.remove('is-playing');
              poster && poster.classList.remove('is-hidden');
              armAutoplayRetry(video);
            });
        }
      }

      if (video.dataset.loadedSrc === src && src) {
        tryPlay();
        return;
      }
      setVideoSource(video, src, tryPlay);
    });
  }

  function initSection(section) {
    if (!section) return;
    destroySection(section);

    var flkty = initSlider(section);
    section.querySelectorAll('.customer-love-it__video-wrap').forEach(function (wrap) {
      initVideoWrap(wrap, section, flkty);
    });

    autoplayAllVideos(section);
  }

  function destroySection(section) {
    if (!section) return;
    var slider = section.querySelector('.customer-love-it__slider');
    if (slider && slider._customerLoveItFlkty) {
      slider._customerLoveItFlkty.destroy();
      slider._customerLoveItFlkty = null;
    }
    section.querySelectorAll('.customer-love-it__video-wrap').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      if (video && video.hlsInstance) {
        try {
          video.hlsInstance.destroy();
        } catch (e) {}
      }
      delete wrap.dataset.videoInit;
    });
    delete section.dataset.customerLoveItInit;
    delete section._customerLoveItResizeBound;
  }

  function whenFlickityReady(callback) {
    if (typeof Flickity !== 'undefined') {
      callback();
      return;
    }
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (typeof Flickity !== 'undefined') {
        window.clearInterval(timer);
        callback();
      } else if (tries > 80) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-section-type="customer-love-it"]').forEach(initSection);
  }

  function start(root) {
    whenFlickityReady(function () {
      boot(root || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start(document);
    });
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (section.matches && section.matches('[data-section-type="customer-love-it"]')) {
      whenFlickityReady(function () {
        initSection(section);
      });
      return;
    }
    section = event.target.querySelector('[data-section-type="customer-love-it"]');
    if (section) {
      whenFlickityReady(function () {
        initSection(section);
      });
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    if (section.matches && section.matches('[data-section-type="customer-love-it"]')) {
      destroySection(section);
      return;
    }
    section = event.target.querySelector('[data-section-type="customer-love-it"]');
    if (section) destroySection(section);
  });
})();













/**
 * Customer Love It — video carousel (Flickity + optional HLS)
 */
// (function () {
//   'use strict';

//   var HLS_SRC = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.7/dist/hls.min.js';

//   function loadHlsJs(callback) {
//     if (window.Hls) {
//       callback();
//       return;
//     }
//     if (window.__customerLoveItHlsLoading) {
//       window.__customerLoveItHlsLoading.then(callback);
//       return;
//     }
//     window.__customerLoveItHlsLoading = new Promise(function (resolve, reject) {
//       var script = document.createElement('script');
//       script.src = HLS_SRC;
//       script.async = true;
//       script.onload = resolve;
//       script.onerror = reject;
//       document.head.appendChild(script);
//     });
//     window.__customerLoveItHlsLoading.then(callback).catch(function () {});
//   }

//   var MOBILE_MAX = 740;

//   function isMobileViewport() {
//     return window.innerWidth <= MOBILE_MAX;
//   }

//   function isMobilePeek(slider) {
//     return isMobileViewport() && slider.dataset.mobilePeek === 'true';
//   }

//   function getSlidesToShow(slider) {
//     var w = window.innerWidth;
//     if (w > 1024) return parseFloat(slider.dataset.slidesDesktop) || 3;
//     if (w >= 768) return parseFloat(slider.dataset.slidesTablet) || 2;
//     if (isMobilePeek(slider)) return 1;
//     return parseFloat(slider.dataset.slidesMobile) || 1;
//   }

//   function getCellAlign(slider) {
//     if (isMobilePeek(slider)) return 'center';
//     if (isMobileViewport()) return 'left';
//     return 'center';
//   }

//   function syncMobilePeekClass(slider) {
//     slider.classList.toggle('customer-love-it__slider--mobile-peek', isMobilePeek(slider));
//   }

//   function pauseAllVideos(section, exceptWrap) {
//     section.querySelectorAll('.customer-love-it__video-wrap').forEach(function (wrap) {
//       if (exceptWrap && wrap === exceptWrap) return;
//       var video = wrap.querySelector('video');
//       var playBtn = wrap.querySelector('.customer-love-it__play');
//       var poster = wrap.querySelector('.customer-love-it__poster');
//       var muteBtn = wrap.querySelector('.customer-love-it__mute');
//       if (!video) return;
//       video.pause();
//       video.muted = true;
//       playBtn && playBtn.classList.remove('is-playing');
//       poster && poster.classList.remove('is-hidden');
//       muteBtn && muteBtn.classList.add('is-muted');
//     });
//   }

//   function attachProgress(video, wrap) {
//     var bar = wrap.querySelector('.customer-love-it__progress-fill');
//     if (!bar) return;
//     var rafId = null;

//     function tick() {
//       if (!video.paused && !video.ended && video.duration > 0) {
//         bar.style.width = (video.currentTime / video.duration) * 100 + '%';
//         rafId = requestAnimationFrame(tick);
//       }
//     }

//     video.addEventListener('play', function () {
//       cancelAnimationFrame(rafId);
//       rafId = requestAnimationFrame(tick);
//     });
//     video.addEventListener('pause', function () {
//       cancelAnimationFrame(rafId);
//     });
//     video.addEventListener('ended', function () {
//       cancelAnimationFrame(rafId);
//       bar.style.width = '0%';
//     });
//   }

//   function setVideoSource(video, src, onReady) {
//     if (!src) return;
//     var isHls = src.indexOf('.m3u8') !== -1;

//     if (video.hlsInstance) {
//       try {
//         video.hlsInstance.destroy();
//       } catch (e) {}
//       video.hlsInstance = null;
//     }

//     video.removeAttribute('src');
//     Array.from(video.querySelectorAll('source')).forEach(function (s) {
//       s.remove();
//     });

//     function done() {
//       video.dataset.loadedSrc = src;
//       if (typeof onReady === 'function') onReady();
//     }

//     if (isHls && video.canPlayType('application/vnd.apple.mpegurl')) {
//       video.src = src;
//       video.addEventListener('loadedmetadata', done, { once: true });
//       video.load();
//       return;
//     }

//     if (isHls) {
//       loadHlsJs(function () {
//         if (!window.Hls || !Hls.isSupported()) {
//           video.src = src;
//           video.addEventListener('loadedmetadata', done, { once: true });
//           video.load();
//           return;
//         }
//         var hls = new Hls({ maxBufferLength: 4, startLevel: -1 });
//         hls.loadSource(src);
//         hls.attachMedia(video);
//         video.hlsInstance = hls;
//         hls.on(Hls.Events.MANIFEST_PARSED, done);
//       });
//       return;
//     }

//     var source = document.createElement('source');
//     source.src = src;
//     source.type = 'video/mp4';
//     video.appendChild(source);
//     video.addEventListener('loadedmetadata', done, { once: true });
//     video.load();
//   }

//   function playVideo(wrap, section, flkty) {
//     var video = wrap.querySelector('video');
//     var playBtn = wrap.querySelector('.customer-love-it__play');
//     var poster = wrap.querySelector('.customer-love-it__poster');
//     var muteBtn = wrap.querySelector('.customer-love-it__mute');
//     if (!video) return;

//     var src = video.dataset.videoSrc;
//     var cell = wrap.closest('.customer-love-it__cell');

//     if (flkty && cell && !cell.classList.contains('is-selected')) {
//       var idx = -1;
//       for (var i = 0; i < flkty.cells.length; i++) {
//         if (flkty.cells[i].element === cell) {
//           idx = i;
//           break;
//         }
//       }
//       if (idx >= 0) flkty.select(idx);
//     }

//     function startPlayback() {
//       pauseAllVideos(section, wrap);
//       video.muted = false;
//       muteBtn && muteBtn.classList.remove('is-muted');
//       var promise = video.play();
//       if (promise && promise.then) {
//         promise
//           .then(function () {
//             playBtn && playBtn.classList.add('is-playing');
//             poster && poster.classList.add('is-hidden');
//           })
//           .catch(function () {
//             playBtn && playBtn.classList.remove('is-playing');
//             poster && poster.classList.remove('is-hidden');
//           });
//       }
//     }

//     if (video.dataset.loadedSrc === src && src) {
//       startPlayback();
//       return;
//     }

//     setVideoSource(video, src, startPlayback);
//   }

//   function initVideoWrap(wrap, section, flkty) {
//     if (wrap.dataset.videoInit === '1') return;
//     wrap.dataset.videoInit = '1';

//     var video = wrap.querySelector('video');
//     var playBtn = wrap.querySelector('.customer-love-it__play');
//     var muteBtn = wrap.querySelector('.customer-love-it__mute');
//     var poster = wrap.querySelector('.customer-love-it__poster');
//     if (!video) return;

//     attachProgress(video, wrap);

//     playBtn &&
//       playBtn.addEventListener('click', function () {
//         if (video.paused) {
//           playVideo(wrap, section, flkty);
//         } else {
//           video.pause();
//           video.muted = true;
//           playBtn.classList.remove('is-playing');
//           poster && poster.classList.remove('is-hidden');
//           muteBtn && muteBtn.classList.add('is-muted');
//         }
//       });

//     muteBtn &&
//       muteBtn.addEventListener('click', function () {
//         video.muted = !video.muted;
//         muteBtn.classList.toggle('is-muted', video.muted);
//         var mutedLabel = muteBtn.getAttribute('data-muted-label');
//         var unmutedLabel = muteBtn.getAttribute('data-unmuted-label');
//         muteBtn.setAttribute('aria-label', video.muted ? mutedLabel : unmutedLabel);
//       });

//     video.addEventListener('playing', function () {
//       poster && poster.classList.add('is-hidden');
//       playBtn && playBtn.classList.add('is-playing');
//     });

//     video.addEventListener('ended', function () {
//       playBtn && playBtn.classList.remove('is-playing');
//       poster && poster.classList.remove('is-hidden');
//       if (flkty) flkty.next();
//     });
//   }

//   function initSlider(section) {
//     var slider = section.querySelector('.customer-love-it__slider');
//     if (!slider || typeof Flickity === 'undefined') return null;

//     if (slider._customerLoveItFlkty) {
//       slider._customerLoveItFlkty.destroy();
//       slider._customerLoveItFlkty = null;
//     }

//     syncMobilePeekClass(slider);

//     var cells = slider.querySelectorAll('.customer-love-it__cell');
//     var total = cells.length;
//     var slidesToShow = getSlidesToShow(slider);
//     var mobilePeek = isMobilePeek(slider);
//     var wrapAround = total > slidesToShow;
//     var showNav = slider.dataset.showNav === 'true' && wrapAround && !mobilePeek;

//     var flkty = new Flickity(slider, {
//       cellSelector: '.customer-love-it__cell',
//       cellAlign: getCellAlign(slider),
//       contain: mobilePeek ? false : !wrapAround,
//       wrapAround: wrapAround,
//       imagesLoaded: true,
//       prevNextButtons: showNav,
//       pageDots: false,
//       draggable: wrapAround,
//       adaptiveHeight: false,
//       percentPosition: false
//     });

//     slider._customerLoveItFlkty = flkty;

//     var lastSlides = slidesToShow;
//     var lastAlign = getCellAlign(slider);
//     var lastPeek = mobilePeek;

//     function onResize() {
//       syncMobilePeekClass(slider);
//       var nextSlides = getSlidesToShow(slider);
//       var nextAlign = getCellAlign(slider);
//       var nextPeek = isMobilePeek(slider);
//       if (nextSlides !== lastSlides || nextAlign !== lastAlign || nextPeek !== lastPeek) {
//         lastSlides = nextSlides;
//         lastAlign = nextAlign;
//         lastPeek = nextPeek;
//         initSlider(section);
//         return;
//       }
//       flkty.resize();
//     }

//     if (!section._customerLoveItResizeBound) {
//       section._customerLoveItResizeBound = true;
//       window.addEventListener('resize', onResize);
//     }

//     flkty.on('settle', function () {
//       autoplaySelectedSlide(section, flkty);
//     });

//     return flkty;
//   }

//   function autoplaySelectedSlide(section, flkty) {
//     if (!flkty || !flkty.selectedElement) return;
//     var wrap = flkty.selectedElement.querySelector('.customer-love-it__video-wrap');
//     var video = wrap && wrap.querySelector('video');
//     var playBtn = wrap && wrap.querySelector('.customer-love-it__play');
//     var poster = wrap && wrap.querySelector('.customer-love-it__poster');
//     var muteBtn = wrap && wrap.querySelector('.customer-love-it__mute');
//     if (!video) return;

//     pauseAllVideos(section, wrap);
//     video.muted = true;
//     muteBtn && muteBtn.classList.add('is-muted');

//     var src = video.dataset.videoSrc;
//     function tryPlay() {
//       var promise = video.play();
//       if (promise && promise.then) {
//         promise
//           .then(function () {
//             playBtn && playBtn.classList.add('is-playing');
//             poster && poster.classList.add('is-hidden');
//           })
//           .catch(function () {
//             playBtn && playBtn.classList.remove('is-playing');
//             poster && poster.classList.remove('is-hidden');
//           });
//       }
//     }

//     if (video.dataset.loadedSrc === src && src) {
//       tryPlay();
//       return;
//     }
//     setVideoSource(video, src, tryPlay);
//   }

//   function initSection(section) {
//     if (!section) return;
//     destroySection(section);

//     var flkty = initSlider(section);
//     section.querySelectorAll('.customer-love-it__video-wrap').forEach(function (wrap) {
//       initVideoWrap(wrap, section, flkty);
//     });

//     if (flkty) autoplaySelectedSlide(section, flkty);
//   }

//   function destroySection(section) {
//     if (!section) return;
//     var slider = section.querySelector('.customer-love-it__slider');
//     if (slider && slider._customerLoveItFlkty) {
//       slider._customerLoveItFlkty.destroy();
//       slider._customerLoveItFlkty = null;
//     }
//     section.querySelectorAll('.customer-love-it__video-wrap').forEach(function (wrap) {
//       var video = wrap.querySelector('video');
//       if (video && video.hlsInstance) {
//         try {
//           video.hlsInstance.destroy();
//         } catch (e) {}
//       }
//       delete wrap.dataset.videoInit;
//     });
//     delete section.dataset.customerLoveItInit;
//     delete section._customerLoveItResizeBound;
//   }

//   function whenFlickityReady(callback) {
//     if (typeof Flickity !== 'undefined') {
//       callback();
//       return;
//     }
//     var tries = 0;
//     var timer = window.setInterval(function () {
//       tries += 1;
//       if (typeof Flickity !== 'undefined') {
//         window.clearInterval(timer);
//         callback();
//       } else if (tries > 80) {
//         window.clearInterval(timer);
//       }
//     }, 50);
//   }

//   function boot(root) {
//     var scope = root && root.querySelectorAll ? root : document;
//     scope.querySelectorAll('[data-section-type="customer-love-it"]').forEach(initSection);
//   }

//   function start(root) {
//     whenFlickityReady(function () {
//       boot(root || document);
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', function () {
//       start(document);
//     });
//   } else {
//     start(document);
//   }

//   document.addEventListener('shopify:section:load', function (event) {
//     var section = event.target;
//     if (section.matches && section.matches('[data-section-type="customer-love-it"]')) {
//       whenFlickityReady(function () {
//         initSection(section);
//       });
//       return;
//     }
//     section = event.target.querySelector('[data-section-type="customer-love-it"]');
//     if (section) {
//       whenFlickityReady(function () {
//         initSection(section);
//       });
//     }
//   });

//   document.addEventListener('shopify:section:unload', function (event) {
//     var section = event.target;
//     if (section.matches && section.matches('[data-section-type="customer-love-it"]')) {
//       destroySection(section);
//       return;
//     }
//     section = event.target.querySelector('[data-section-type="customer-love-it"]');
//     if (section) destroySection(section);
//   });
// })();
